export const STATE_NAME = "httpCache";
// 15 minute timeout for request cache
export const CACHE_TIMEOUT = 900000;
